export default chipInfo => {
    const { title, id, type, code } = chipInfo;

    const input = document.createElement('input');

    input.setAttribute('value', id);
    document.body.appendChild(input);
    input.select();
    if (document.execCommand('copy')) {
        document.execCommand('copy');
        alert(`碎片id（${id}）type (${type}) title ${title} 复制成功(只复制了id)${decodeURIComponent(code)}`);
    }
    setTimeout(() => {
        document.body.removeChild(input);
    }, 100);
};
